import React from "react";
import s from "./FixedButton.module.scss";

export default function FixedButton(props) {
  return <div className={s.fixedButton} onClick={props.click}>
    {props.text}
  </div>;
}
